<template>
    <div id="app" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
        <globalToast></globalToast>
        <comingSoon></comingSoon>
        <collectionSuccessPop></collectionSuccessPop>
        <guessLike 
            :likeLists="likeLists" 
            :pageCover="pageCover" 
            @clickLike="clickLike" 
            @closePageCover="closePageCover" 
            @clickRightCantactUs="clickRightCantactUs"
        ></guessLike>
        <keep-alive>
            <router-view v-if="$route.meta && $route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
    </div>
</template>

<script>
import api from '@/api';
import { isWechatBrowser, replaceCdnUrl, getUrlKey, getTime, sortKey } from "@/utils/tool";
import globalToast from "components/globalToast";
import comingSoon from "components/comingSoonPop";
import guessLike from 'components/guessLike';
import collectionSuccessPop from 'components/collectionSuccessPop';
  export default {
      name: 'app',
      components: {
        globalToast,comingSoon,guessLike,collectionSuccessPop
      },
      created(){
        document.addEventListener('touchmove', this.controlScroll, {passive: false});
        this.getAgendaList();
        this.getExtHall();
        this.getTc();
        // this.agendaStatus();
        this.getWxShareConfig();
      },
      computed:{
            showGlobalToast(){
                return this.$store.state.showGlobalToast;
            },
            showGlobalToastTime(){
                return this.$store.state.showGlobalToastTime;
            },
        },
      watch:{
          showGlobalToast(newVal, oldVal){
              if(newVal && !oldVal){
                this.globalToastCountDown();
              }else{
                  return;
              }
          }
      },
      mounted(){
      },
      data(){
        return{
            globalToastTimeoutGuardId: false,
            agenda: [],
            hallList: [],
            likeLists: [],
            hallListRequest: false,
            agendaListRequest: false,
            isRecommend: false,
            pageCover: false,
            recommendTimeGuard: 0,
            touchStartY: 0,
        }
      },
      methods:{
        agendaStatus(){
            let status = '';
            let currentTime = getTime();
            if(currentTime < 1621180800){
                status = 'before';
            }else if(currentTime > 1621180800 && currentTime < 1621353600){
                status = 'middle';
            }else if(currentTime > 1621353600){
                status = 'after';
            }
            this.$store.commit('setAgendaStatus', status);
        },
        globalToastCountDown(){
            if(this.showGlobalToast && this.showGlobalToastTime >= 0){
                this.$store.commit('setShowGlobalToastTime', this.showGlobalToastTime - 1);
                let that = this;
                this.globalToastTimeoutGuardId = setTimeout(function(){
                    that.globalToastCountDown();
                }, 1000);
            }else{
                this.$store.commit('setShowGlobalToast', false);
                this.$store.commit('setShowGlobalToastTime', 0);
                this.$store.commit('setShowGlobalToastMsg', '');
                window.clearTimeout(this.globalToastTimeoutGuardId);
                return;
            }

        },
        getTc(){
            if(getUrlKey('tc')){
                localStorage.setItem('eco_2021_agenda_tc', getUrlKey('tc'));
            }else{
                localStorage.setItem('eco_2021_agenda_tc', '');
            }

            if(getUrlKey('shareKey')){
                localStorage.setItem('eco_2021_agenda_shareKey', getUrlKey('shareKey'));
            }else{
                localStorage.setItem('eco_2021_agenda_shareKey', '');
            }
        },
        getUserOrderStatus(){
            let that = this;
            api.getUserOrderStatus()
            .then(res=>{
                if(res.result == 0){

                    let orderOffline = 9;
                    let orderOnline = 9;
                    if(res.content.status[this.$config.seminarId] == 0){
                        // 未预约
                        orderOffline = 0;
                    }else if(res.content.status[this.$config.seminarId] == 2 || res.content.status[this.$config.seminarId] == 3){
                        // 已预约
                        orderOffline = 1;
                    }else if(res.content.status[this.$config.seminarId] == 1){
                        // 审核中
                        orderOffline = 2;
                    }else if(res.content.status[this.$config.seminarId] == 4){
                        // 已拒绝
                        orderOffline = 2;
                    }else{
                        orderOffline = 9;
                    }

                    if(res.content.status[this.$config.onlineSeminarId] == 0){
                        // 未预约
                        orderOnline = 0;
                    }else if(res.content.status[this.$config.onlineSeminarId] == 2 || res.content.status[this.$config.onlineSeminarId] == 3){
                        // 已预约
                        orderOnline = 1;
                    }else if(res.content.status[this.$config.onlineSeminarId] == 1){
                        // 审核中
                        orderOnline = 2;
                    }else if(res.content.status[this.$config.onlineSeminarId] == 4){
                        // 已拒绝
                        orderOnline = 3;
                    }else{
                        orderOnline = 9;
                    }
                    that.$store.commit('setOrderOffline', orderOffline);
                    that.$store.commit('setOrderOnline', orderOnline);
                    that.$store.commit('setIsLogin', true);
                    that.$store.commit('setRelationId', res.content.status.onlineRelation);
                }else{
                    that.$store.commit('setOrderOffline', 0);
                    that.$store.commit('setOrderOnline', 0);
                }
            })
            .catch(err=>{
                that.$store.commit('setOrderOffline', 0);
                that.$store.commit('setOrderOnline', 0);
            });
        },  
        getSeminarInfo(){
            let that = this;
            api.getNewSubSeminarInfo()
            .then(res=>{
            })
            .catch(err=>{
            });
        },
        // 获取微信分享设置
        getWxShareConfig(){
            if(!isWechatBrowser()){
                return;
            }else{
                api.getWxShareConfig()
                .then(res=>{
                    if(res.result == 0){
                        let shareImg = '', shareTitle = '', shareDesc = '';
                        shareImg = replaceCdnUrl(res.content.coverImageRealPath);
                        let temp = res.content.summary.split('^');
                        if(temp.length == 1){
                            shareTitle = temp[0];
                        }
                        if(temp.length == 2){
                            shareTitle = temp[0];
                            shareDesc = temp[1];
                        }

                        if(shareImg){
                            window.$config.shareImgUrl = 'https:' + shareImg;
                        }
                        if(shareTitle){
                            window.$config.shareTitle = shareTitle;
                        }
                        if(shareDesc){
                            window.$config.shareDesc = shareDesc;
                        }
                    }
                })
                .catch(err=>{
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });

            }
        },
        // 议程
        getAgendaList(){
            let that = this;
            api.getNewSubSeminarList()
            .then(res=>{
                that.agenda = res;
                that.agendaListRequest = true;
                that.initRecommend();
            })
            .catch(err=>{
            });
        },
        // 猜你喜欢-展厅数据
        getExtHall(){
            let that = this;
            api.getExthallList()
            .then(res=>{
                that.hallList = res;
                that.hallListRequest = true;
                that.initRecommend();
            })
            .catch(err=>{
            });
        },
        initRecommend(){
            // if(this.isRecommend){
            //     return;
            // }
            if(this.agendaListRequest && this.hallListRequest){
                let that = this;
                // that.isRecommend = true;
                try{
                    _hpm("getTags", {
                        callback: res => {
                            if(!res){
                                res = {industry: null, productAndSolution: null};
                            }
                            that.recommend(res);
                        },
                    });
                }catch(e){
                    let tags = {industry: null, productAndSolution: null};
                    let cache = localStorage.getItem('hypers_hpm_tags');
                    if(cache && cache != 'undefined'){
                        cache = JSON.parse(cache);
                        if(cache.hasOwnProperty('industry') && cache.hasOwnProperty('productAndSolution')){
                            tags = cache;
                        }
                    }
                    that.recommend(tags);
                }
            }
        },
        recommend(tags){
            let industryTag = '行业$默认标签',
                productTag = '产品$默认标签';
            if(tags.industry && tags.industry.tagName){
                industryTag = '行业$' + tags.industry.tagName.replace('-', '^');
            }
            if(tags.productAndSolution && tags.productAndSolution.tagName){
                productTag = '产品$' + tags.productAndSolution.tagName.replace('-', '^');
            }

            console.log('recommend', industryTag, productTag);

            let agendaRes = this.recommendAgenda(industryTag, productTag);

            let hallRes = this.recommendHall(industryTag, productTag);
            let likeLists = [
                {
                    likeOneTitle:"议程",
                    likeContent: agendaRes.agenda
                },
                {
                    likeOneTitle:"展厅",
                    likeContent: hallRes
                },
            ];
            if(agendaRes.file){
                likeLists[2] = {
                    likeOneTitle:"资料",
                    likeContent: [agendaRes.file]
                };
            }
            this.likeLists = likeLists;

            let that = this;
            this.recommendTimeGuard = setTimeout(function(){
                that.initRecommend();
            }, 5000);
        },
        recommendHall(industryTag, productTag){
            let data = [];
            data = data.concat(this.hallList[0].child);
            data = data.concat(this.hallList[1].child);
            data = data.concat(this.hallList[2].child);

            data.map(item=>{
                item.m_tag_score = 0;
                if(item.m_tag && item.m_tag.indexOf(industryTag) != -1){
                    item.m_tag_score = item.m_tag_score + 500;
                }
                if(item.m_tag && item.m_tag.indexOf(productTag) != -1){
                    item.m_tag_score = item.m_tag_score + 500;
                }

                if(item.m_tag_score > 0){
                    item.m_tag_score = item.m_tag_score - item.tags.length;
                }
            });

            data = sortKey(data, 'm_tag_score');

            return data.slice(0, 2);
        },
        recommendAgenda(industryTag, productTag){
            let agenda = [];
            agenda = agenda.concat(this.agenda.first.topic);
            agenda = agenda.concat(this.agenda.first.special);
            agenda = agenda.concat(this.agenda.first.open);
            agenda = agenda.concat(this.agenda.second.topic);
            agenda = agenda.concat(this.agenda.second.special);
            agenda = agenda.concat(this.agenda.second.open);
            
            agenda.map(item=>{
                if(item.m_tag.indexOf(industryTag) != -1){
                    item.m_tag_score = item.m_tag_score + 500;
                }
                if(item.m_tag.indexOf(productTag) != -1){
                    item.m_tag_score = item.m_tag_score + 500;
                }

                if(item.m_tag_score > 0){
                    item.m_tag_score = item.m_tag_score - item.m_tag.length;
                }
            });

            let yihou = [], guoqu = [];
            agenda.map(item=>{
                if(item.timeIndex > 0){
                    yihou.push(item);
                }else{
                    guoqu.push(item);
                }
            });

            yihou = sortKey(yihou, 'timeIndex').reverse();
            guoqu = sortKey(guoqu, 'timeIndex');

            let res = yihou.concat(guoqu);
            res = sortKey(res, 'm_tag_score');


            let fileInfo = false;
            let zipSpecialListOri = false;
            let specialCache = this.$store.state.cache.specialFiles;
            if(specialCache){
                zipSpecialListOri = specialCache.content.content;
            }

            if(this.$store.state.agendaStatus == 'after'){
                let fileIdArr = [];
                res.map(item=>{
                    if(item.categoryArr[0] == '主题演讲'){
                        if(item.filesIdArr.length > 0){
                            fileIdArr = fileIdArr.concat(item.filesIdArr);
                        }
                    }else if(item.categoryArr[0] == '专题演讲' && zipSpecialListOri){
                        // console.log('mark bug', zipSpecialListOri);
                        if(zipSpecialListOri.hasOwnProperty(item.subSeminarId * 1)){
                            zipSpecialListOri[item.subSeminarId * 1].map(specItem=>{
                                fileIdArr.push(specItem.fileId);
                            });
                        }
                    }
                });

                if(fileIdArr.length > 0){
                    let fileId = fileIdArr[0];
                    let fileCache = this.$store.state.cache.fileList;
                    fileCache.map(cacheItem=>{
                        if(cacheItem.fileId == fileId){
                            fileInfo = cacheItem;
                        }
                    })
                }
            }

            return {
                agenda: this.$store.state.agendaStatus == 'after' ? res.slice(0, 2) : res.slice(0, 3),
                file: fileInfo
            };
        },
        clickRightCantactUs(){
            this.pageCover = true;

            // 埋码
            this.$maima.index_contact_us_click();
        },
        closePageCover(){
            this.pageCover = false;
            return;
        },
        clickLike(item, key){
            if(key == 0){

                // 埋码
                this.$maima.index_recommendation_agenda_btn_click(item.name, item.m_product_tag, item.industry_tag);

                localStorage.setItem("eco_2021_agenda_hash", JSON.stringify({
                    dayIndex: item.dayIndex,
                    typeIndex: item.typeIndex,
                    indexKey: item.indexKey,
                    agendaThemeActive: item.indexKey

                }));
                if(this.$route.path.indexOf('/agenda') == -1){
                    this.$router.push({
                        path: '/agenda'
                    });
                }else{
                    this.$store.commit('setAgendaLikeTrigger');
                }
                
            }else if(key == 1){

                // 埋码
                this.$maima.index_recommendation_exhibition_btn_click(item.title, item.m_product_tag, item.industry_tag);

                if(this.$route.path.indexOf('/exhibitionDetail') == -1){
                    this.$router.push({
                        path: '/exhibitionDetail',
                        query: {
                            id: item.articleCategoryId
                        }
                    });
                }else{
                    if(this.$route.query.id != item.articleCategoryId){
                        // window.location.href = window.$config.url.self + '/exhibitionDetail?id=' + item.articleCategoryId;
                        window.location.href = window.location.href.split('?')[0] + '?id=' + item.articleCategoryId;
                    }else{
                        return;
                    }
                }
            }else{

                // 埋码
                this.$maima.index_recommendation_material_btn_click(item.name);

                if(this.$route.path.indexOf('/files') == -1){
                    this.$router.push({
                        path: '/files'
                    })
                }else{
                    return;
                }

                
            }
            return;
        },
        handleTouchStart(e){
            if(this.$store.state.isPc){
                return;
            }else{
                this.touchStartY = e.changedTouches[0].pageY;
                // document.addEventListener('touchmove', this.controlScroll, {passive: false});
            }    
        },
        handleTouchMove(e){
            if(this.$store.state.isPc){
                return;
            }else{
                if(this.$store.state.wapNavIsShow){

                    let ulHeight = $(".nav-main").height();
                    let scrollTop = $(".nav-main").scrollTop();
                    let scrollheight = $(".nav-main")[0].scrollHeight;

                    if((ulHeight+scrollTop) / scrollheight > 0.98 && e.changedTouches[0].pageY < this.touchStartY){
                        if(this.$store.state.allowScroll){
                            this.$store.commit('setAllowScroll', false);
                        }

                    }else if(scrollTop == 0 && e.changedTouches[0].pageY > this.touchStartY){
                        this.$store.commit('setAllowScroll', false);
                        
                    }else{
                        if(!this.$store.state.allowScroll){
                            this.$store.commit('setAllowScroll', true);
                        }
                    }
                }
                else if(this.$store.state.wapGuessLikeShow){
                    let likeUlHeight = $("#guess-container").height();
                    let likeScrollTop = $("#guess-container").scrollTop();
                    let likeScrollheight = $("#guess-container")[0].scrollHeight;

                    if((likeUlHeight+likeScrollTop ) / likeScrollheight  > 0.985 && e.changedTouches[0].pageY < this.touchStartY){
                        if(this.$store.state.allowScroll){
                            this.$store.commit('setAllowScroll', false);
                        }

                    }else if(likeScrollTop == 0 && e.changedTouches[0].pageY > this.touchStartY){
                        this.$store.commit('setAllowScroll', false);
                        
                    }else{
                        if(!this.$store.state.allowScroll){
                            this.$store.commit('setAllowScroll', true);
                        }
                    }
                }
                else{
                    if(e.changedTouches[0].pageY > this.touchStartY && window.scrollY == 0){
                        if(this.$store.state.allowScroll){
                            // this.allowScroll = false;
                            this.$store.commit('setAllowScroll', false);
                            // document.addEventListener('touchmove', this.disableScroll, {passive: false});
                        }
                    }
                    else{
                        if(!this.$store.state.allowScroll){
                            // this.allowScroll = true;
                            this.$store.commit('setAllowScroll', true);
                            // document.addEventListener('touchmove', this.enableScroll, {passive: false});
                        }
                    }
                }
            }
        },
        handleTouchEnd(e){
            if(this.$store.state.isPc){
                return;
            }else{
                // document.removeEventListener('touchmove', this.controlScroll, {passive: false});
            }
        },
        controlScroll(e){
            if(this.$store.state.allowScroll){
                return;
            }else{
                e.preventDefault();
                e.stopPropagation();
            }
        },
    }
};
</script>
<style scoped lang="scss">
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .app-content{
        min-height: 100vh;
    }

</style>
